import React, { Component } from 'react';
import { Button, Container, Row, Col } from 'reactstrap';
import Butt from './Butt';
import ActionLink from './ActionLink';
import API from '../API';
import { T, TraksConsumer } from '../traks';
import { Modal, ModalOpen, ModalClose, ModalUpdate } from '../Modal';
import { R } from '../routes';
import { current_site_id, site_name } from '../Site';

import { AUAContainer } from '../AUA';

const input_classname = (more, has_error) => {
	var c = "form-control p-3 ad_signuplogin_input ";
	if (more) c += more;
	if (has_error) c += " ad_input_error";
	return c;
};

function OpenLogin() {
	OpenLoginWithRedirect(null);
}

function OpenLoginWithRedirect(redirect_to) {
	ModalOpen("SignupLoginModal", {kind: "login", redirect_to});
}

function OpenLoginWithSuccessCallback(success_callback) {
	ModalOpen("SignupLoginModal", {kind: "login", success_callback});
}

function OpenSignup() {
	OpenSignupWithRedirect(null);
}

function OpenSignupAndJoinGame(join_game_id, invite_key, payload) {
	const success_callback = () => {
		API.post("/a/accept_game_invite", {game_id: join_game_id, key: invite_key, payload}, () => {
			window.location.reload();
		});
	};
	ModalOpen("SignupLoginModal", {kind: "signup", join_game_id, invite_key, payload, success_callback});
}

function OpenSignupWithRedirect(redirect_to) {
	ModalOpen("SignupLoginModal", {kind: "signup", redirect_to});
}

function OpenSignupWithSuccessCallback(success_callback) {
	ModalOpen("SignupLoginModal", {kind: "signup", success_callback})
}

function OpenForgotPassword() {
	ModalOpen("SignupLoginModal", {kind: "forgot_password"});
}

function set_kind(kind) {
	ModalUpdate("SignupLoginModal", {kind}, ["redirect_to", "success_callback"]);
}

function set_login() { set_kind("login"); }
function set_forgot_password() { set_kind("forgot_password"); }
function set_signup() { set_kind("signup"); }
function set_signup_local() { set_kind("signup_local"); }

function handle_post_success(props) {
	if (props.success_callback) {
		props.success_callback();
	}
	if (props.redirect_to) {
		R.goto_url(props.redirect_to);
	}
}

const get_oauth_fn_pair = (aua, props) => {
	const { join_game_id, invite_key, payload } = props;
	if (join_game_id) {
		return [
			() => aua.request.oauth.login_and_join_game.fb(join_game_id, invite_key, payload),
			() => aua.request.oauth.login_and_join_game.twtr(join_game_id, invite_key, payload),
		];
	} else {
		return [
			aua.request.oauth.login.fb,
			aua.request.oauth.login.twtr
		];
	}
};

class Login extends Component {
	constructor(props) {
		super(props);
		this.state = {email: props.initial_email || "", password: "", invalid_username_or_password: false};
		this.did_focus = false;
	}

	render() {
		const { aua } = this.props

		const submit = (e) => {
			e.preventDefault();
			aua.request.login(this.state.email, this.state.password, (err) => {
				if (err) {
					this.setState({invalid_username_or_password: true});
				} else {
					ModalClose();
					handle_post_success(this.props);
				}
			});
		};

		const change = (e) => {
			this.setState({[e.target.name]: e.target.value});
		};

		var err;
		if (this.state.invalid_username_or_password) {
			err = <T>Wrong username or password</T>;
		}

		const focus_once = (ref) => {
			if (ref && this.did_focus === false) {
				ref.focus();
				this.did_focus = true;
			}
		};
		const email_value = this.state.email;
		const password_value = this.state.password;

		const [ login_fb, login_twtr ] = get_oauth_fn_pair(aua, this.props);

		return (
			<Row>
				<Col className="ad_signuplogin_dark">
					<div className="mx-sm-5 mt-5">
						<form onSubmit={submit}>
							<Row>
								<Col><T>
									<input
										ref={focus_once}
										placeholder="Email"
										className={input_classname("mb-5")}
										type="email"
										name="email"
										value={email_value}
										onChange={change}
									/>
								</T></Col>
							</Row>
							<Row>
								<Col><T>
									<input
										placeholder="Password"
										className={input_classname("mb-3")}
										type="password"
										name="password"
										value={password_value}
										onChange={change}
									/>
								</T></Col>
							</Row>
							<div className="errors mb-3">{err}&nbsp;</div>
							<Butt className="ad_rbtn w-100 ad_signuplogin_btn px-5 py-3 mb-3" type="submit"><T>Login</T></Butt>
							<Row className="pb-1">
								<Col>
									<div className="ad_signuplogin_text d-flex align-items-end">
										<T>Or login with</T>
										<ActionLink className="d-none" on_click={login_fb}>
											<img
												alt="Facebook"
												title="Facebook"
												className="mx-2"
												width="18px"
												src="/gfx/sso-facebook-0.svg"
											/>
										</ActionLink>
                                        {/*<T>or</T>*/}
										<ActionLink on_click={login_twtr}>
											<img
												alt="Twitter"
												title="Twitter"
												width="32px"
												style={{position: "relative", top: "7px"}}
												src="/gfx/sso-twitter-0.svg"
											/>
										</ActionLink>
									</div>
								</Col>
							</Row>
							<Row>
								<Col>
									<ActionLink on_click={set_forgot_password} className="ad_signuplogin_text"><T>Forgot your password?</T></ActionLink>
								</Col>
							</Row>
							<Row className="pb-4">
								<Col>
									<ActionLink on_click={set_signup} className="ad_signuplogin_text"><T>Don't have an account?</T></ActionLink>
								</Col>
							</Row>
						</form>
					</div>
				</Col>
			</Row>
		);
	}
}

class ForgotPassword extends Component {
	constructor(props) {
		super(props);
		this.state = {email: ""}
	}

	render() {
		const email_value = this.state.email;
		const change = (e) => {
			this.setState({[e.target.name]: e.target.value});
		};
		const submit = (e) => {
			e.preventDefault();
			API.post("/z/send_password_reset_email", {site: current_site_id, email: this.state.email, lang: this.props.lang}, (response) => {
				ModalClose();
			});
		};
		return (
			<Row>
				<Col className="ad_signuplogin_dark">
					<div className="mx-sm-5 mt-5">
						<form onSubmit={submit}>
							<Row>
								<Col>
									<T><input
										placeholder="Type in your email"
										className={input_classname("mb-5")}
										type="email"
										name="email"
										value={email_value}
										onChange={change}
									/></T>
								</Col>
							</Row>
							<Row className="pb-4">
								<Col>
									<Butt
										className="ad_rbtn w-100 ad_signuplogin_btn px-5 py-3 mb-3"
										type="submit"
									>
									<T>Send password reset email</T>
									</Butt>
								</Col>
							</Row>
						</form>
					</div>
				</Col>
			</Row>
		);
	}
}

const Signup = (props) => {
	const { aua } = props;
	const [ login_fb, login_twtr ] = get_oauth_fn_pair(aua, props);

	return (
		<Row>
			<Col md={5} className="ad_signuplogin_lcol">
				<Container className="pr-5 ad_signuplogin_text">
					<Row className="py-3">
						<Col>
						</Col>
					</Row>
					<Row className="pl-3 pt-4 pb-4">
						<Col md={2}><img alt="money_icon" src="/gfx/money-switch-0.svg" className="ad_34px"/></Col>
						<Col><T>It's completely free. No hidden costs anywhere.</T></Col>
					</Row>

					<Row className="pl-3 py-4">
						<Col md={2}><img alt="compete_icon" src="/gfx/award-0.svg" className="ad_34px"/></Col>
						<Col><T>Compete against friends or win prices in our competitions.</T></Col>
					</Row>

					<Row className="pl-3 py-4">
						<Col md={2}><img alt="security_icon" src="/gfx/security-0.svg" className="ad_34px"/></Col>
						<Col><T>We're completely transparent when it comes to privacy. Find out what we know about you, whenever you want.</T></Col>
					</Row>

					<Row className="py-3">
						<Col>
						</Col>
					</Row>
				</Container>
			</Col>
			<Col md={7} className="ad_signuplogin_rcol">
				<div className="mx-sm-5 mt-4">
				<div className="ad_signup_right_header text-center pb-4"><T>Sign up for Aktiedysten. It's free.</T></div>
					<Row className="pb-3 d-none">
						<Col>
							<Button onClick={login_fb} className="ad_signup_facebook_button w-100"><T>Sign up with Facebook</T></Button>
						</Col>
					</Row>
					<Row className="pb-3">
						<Col>
							<Button onClick={login_twtr} className="ad_signup_twitter_button w-100"><T>Sign up with Twitter</T></Button>
						</Col>
					</Row>
					<Row className="pb-4">
						<Col>
							<Button onClick={set_signup_local} className="ad_signup_email_button w-100"><T>Sign up with email</T></Button>
						</Col>
					</Row>
					<Row className="">
						<Col>
							<span className="ad_signup_right_footer font-small"><T>Already have an account?</T></span><ActionLink on_click={set_login} className="ad_signuplogin_action font-small pl-2"><T>Login here</T></ActionLink>
						</Col>
					</Row>
					<Row>
						<div className="d-block d-md-none ad_mobile_bottom_space"/>
					</Row>
				</div>
			</Col>
		</Row>
	);
}

class SignupLocalAccount extends Component {
	constructor(props) {
		super(props);
		this.state = {
			screen_name: "",
			email: "",
			password: "",
			password_again: "",
			err_screen_name_missing: false,
			err_email_missing: false,
			err_no_password: false,
			err_password_mismatch: false,
			err_invalid_email: false,
			err_email_taken: false,
			have_sacrificed_my_first_born: false,
		};
		this.did_focus = false;
	}

	render() {
		const get_screen_name = () => this.state.screen_name.trim();
		const get_email = () => this.state.email.trim();

		const { aua } = this.props;

		const validate_and_post = (submit_callback) => {
			var new_state = {
				err_screen_name_missing: false,
				err_email_missing: false,
				err_no_password: false,
				err_no_password_again: false,
				err_password_mismatch: false,
				err_invalid_email: false,
				err_email_taken: false,
			};
			const has_email = get_email().length > 0;
			if (submit_callback && get_screen_name().length === 0) new_state.err_screen_name_missing = true;
			if (submit_callback && !has_email) new_state.err_email_missing = true;
			if (this.state.password.length > 0 && this.state.password_again.length > 0 && this.state.password !== this.state.password_again) {
				new_state.err_password_mismatch = true;
			} else if (submit_callback && this.state.password.length === 0 && this.state.password_again.length === 0) {
				new_state.err_no_password = true;
			} else if (submit_callback && this.state.password.length > 0 && this.state.password_again.length === 0) {
				new_state.err_no_password_again = true;
			}

			const has_errors = () => {
				return new_state.err_screen_name_missing ||
					new_state.err_email_missing ||
					new_state.err_no_password ||
					new_state.err_no_password_again ||
					new_state.err_password_mismatch ||
					new_state.err_invalid_email ||
					new_state.err_email_taken;
			}

			const has_local_errors = () => {
				return new_state.err_screen_name_missing ||
					new_state.err_email_missing ||
					new_state.err_no_password ||
					new_state.err_no_password_again ||
					new_state.err_password_mismatch;
			};

			if (has_email) {
				const dryrun = !submit_callback || has_local_errors();

				aua.request.signup(get_email(), this.state.password, get_screen_name(), dryrun, (err) => {
					if (err) {
						switch (err.code) {
						case "email_invalid":
							new_state.err_invalid_email = true;
							break;
						case "email_conflict":
							new_state.err_email_taken = true;
							break;
						default:
							break;
						}
					} else {
						if (submit_callback && !has_errors()) submit_callback();
					}
					this.setState(new_state);
				});
			} else {
				this.setState(new_state);
			}
		};

		const submit = (e) => {
			e.preventDefault();
			validate_and_post(() => {
				ModalClose();
				handle_post_success(this.props);
			});
		};

		const change = (e) => {
			this.setState({[e.target.name]: e.target.value});
		};

		const blur = () => {
			validate_and_post();
		};

		const InputHeader = (props) => {
			var insert_text;
			const err = props.err || [];
			var classes;
			for (const [field, text] of err)  {
				if (this.state[field]) {
					insert_text = text;
					classes = "errors";
					break;
				}
			}

			if (!insert_text) {
				const txt = props.txt || [];
				for (const [field, text] of txt) {
					if (this.state[field]) {
						insert_text = text;
						classes = "ad_signuplogin_input_header";
						break;
					}
				}
			}

			if (!insert_text) {
				insert_text = "WOOP";
				classes = "ad_signuplogin_input_header ad_invisible";
			}

			return <div className={classes}>{insert_text}</div>;
		};

		const focus_once = (ref) => {
			if (ref && this.did_focus === false) {
				ref.focus();
				this.did_focus = true;
			}
		};
		const screen_name_value = this.state.screen_name;
		const email_value = this.state.email;
		const password_value = this.state.password;
		const password_again_value = this.state.password_again;
		const state_err_screen_name_missing = this.state.err_screen_name_missing;
		const state_err_email_missing = this.state.err_email_missing;
		const state_err_invalid_email = this.state.err_invalid_email;
		const state_err_email_taken = this.state.err_email_taken;
		const state_err_password_mismatch = this.state.err_password_mismatch;

		return (
			<Row>
				<Col md={5} className="ad_signuplogin_lcol">
					<div className="ad_signuplogin_header px-4 pt-5 pb-3"><T>Sign up for Aktiedysten. It's free.</T></div>

					<Container className="pr-5 ad_signuplogin_text">
						<Row className="pl-3 py-4">
							<Col md={2}><img alt="money_icon" src="/gfx/money-switch-0.svg" className="ad_34px"/></Col>
							<Col><T>It's completely free. No hidden costs anywhere.</T></Col>
						</Row>

						<Row className="pl-3 py-4">
							<Col md={2}><img alt="compete_icon" src="/gfx/award-0.svg" className="ad_34px"/></Col>
							<Col><T>Compete against friends or win prices in our competitions.</T></Col>
						</Row>

						<Row className="pl-3 py-4">
							<Col md={2}><img alt="security_icon" src="/gfx/security-0.svg" className="ad_34px"/></Col>
							<Col><T>We're completely transparent when it comes to privacy. Find out what we know about you, whenever you want.</T></Col>
						</Row>

						<Row className="pt-4 pb-5">
							<Col>
								<ActionLink on_click={set_login} className="ad_signuplogin_action"><T>Already have an account?</T></ActionLink>
							</Col>
						</Row>
					</Container>
				</Col>
				<Col md={7} className="ad_signuplogin_rcol">
					<div className="mx-sm-5 mt-5">
						<form onSubmit={submit}>
							<Row>
								<Col>
									<T><InputHeader
										txt={[["screen_name", "Name"]]}
										err={[
											["err_screen_name_missing", "You must enter a name"]
										]}
									/></T>
									<T><input
										ref={focus_once}
										placeholder="Name"
										className={input_classname("mb-4", state_err_screen_name_missing)}
										type="text"
										name="screen_name"
										value={screen_name_value}
										onChange={change}
										onBlur={blur}
									/></T>
								</Col>
							</Row>
							<Row>
								<Col>
									<T><InputHeader
										txt={[["email", "Email"]]}
										err={[
											["err_email_missing", "You must enter an email"],
											["err_invalid_email", "The email is invalid"],
											["err_email_taken", "The email is already taken"]
										]}
									/></T>
									<T><input
										placeholder="Email"
										className={input_classname("mb-4", state_err_email_missing || state_err_invalid_email || state_err_email_taken)}
										type="email"
										name="email"
										value={email_value}
										onChange={change}
										onBlur={blur}
									/></T>
								</Col>
							</Row>
							<Row>
								<Col>
									<T><InputHeader
										txt={[["password", "Password"]]}
										err={[
											["err_no_password", "You must enter a password"],
											["err_password_mismatch", "Passwords don't match"],
										]}
									/></T>
									<T><input
										placeholder="Password"
										className={input_classname("mb-4", state_err_password_mismatch)}
										type="password"
										name="password"
										value={password_value}
										onChange={change}
										onBlur={blur}
									/></T>
								</Col>
								<Col>
									<T><InputHeader
										txt={[["password_again", "Password again"]]}
										err={[
											["err_no_password_again", "You must enter your password twice"]
										]}
									/></T>
									<T><input
										placeholder="Password again"
										className={input_classname("mb-4", state_err_password_mismatch)}
										type="password"
										name="password_again"
										value={password_again_value}
										onChange={change}
										onBlur={blur}
									/></T>
								</Col>
							</Row>
							<Row>
								<Col>
									<div className="d-inline-block">
										<label htmlFor="check_this_box" className="pb-3">
											<div className="d-inline-block align-text-bottom">
												<input id="check_this_box" type="checkbox" checked={this.state.have_sacrificed_my_first_born} onChange={() => {this.setState({have_sacrificed_my_first_born: !this.state.have_sacrificed_my_first_born})}}/>
											</div>
											<span className="pl-2 text-white"><T>I've read and accepted both the {site_name} <a target="_blank" className="ad_blue_link" href="/privacy">Privacy Policy</a> and <a target="_blank" className="ad_blue_link" href="/termsofuse">Terms of Use</a>.</T></span>
										</label>
									</div>
								</Col>
							</Row>
							<Butt className="ad_rbtn w-100 ad_signuplogin_btn px-5 py-3 mb-5" type="submit" disabled={!this.state.have_sacrificed_my_first_born}><T>Sign up</T></Butt>
						</form>
					</div>
				</Col>
			</Row>
		);
	}
}

const SignupLoginModalInner = (props) => {
	if (props.kind === undefined) return null;
	var content = null;
	switch (props.kind) {
		case "login": content = <AUAContainer><Login {...props}/></AUAContainer>; break;
		case "forgot_password": content = <TraksConsumer><ForgotPassword {...props}/></TraksConsumer>; break;
		case "signup": content = <AUAContainer><Signup {...props}/></AUAContainer>; break;
		case "signup_local": content = <AUAContainer><SignupLocalAccount {...props}/></AUAContainer>; break;
		default: break;
	}
	return (
		<div className="ad_signuplogin_dark"><Container>{content}</Container></div>
	);
};

class SignupLoginModal extends Modal {
	mrender() {
		return <SignupLoginModalInner {...this.props}/>
	}

	get_name() {
		return "SignupLoginModal";
	}

	get_fullscreen_bg_class() {
		return "ad_signuplogin_dark";
	}

	get_bootstrap_modal_class() {
		switch (this.props.kind) {
		case "login":
		case "forgot_password":
			return "ad_signuplogin_modal_sm";
		case "signup":
		case "signup_local":
			return "ad_signuplogin_modal_lg";
		default:
			return "";
		}
	}
}

export {
	SignupLoginModal,
	OpenLogin,
	OpenLoginWithRedirect,
	OpenLoginWithSuccessCallback,
	OpenSignup,
	OpenSignupWithRedirect,
	OpenSignupWithSuccessCallback,
	OpenSignupAndJoinGame,
	OpenForgotPassword,
}



// WEBPACK FOOTER //
// ./src/c/SignupLogin.js